import { ApolloError, useQuery } from '@apollo/client'
import { SalaryByEmployeeIdQuery, SalaryByEmployeeIdQueryVariables } from '../../../types'

import { SALARY_BY_EMPLOYEE_ID } from '../Queries'

export default (
  employeeId: string,
  resigned = false,
): { data: SalaryByEmployeeIdQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const variables = {
    employeeId: employeeId,
    employeeResigned: resigned,
  }

  const { data, error, loading } = useQuery<SalaryByEmployeeIdQuery, SalaryByEmployeeIdQueryVariables>(SALARY_BY_EMPLOYEE_ID, {
    variables: variables,
  })

  return { data, error, loading }
}
